<template>
  <div class="popUpWrap">
    <section class="popup light" style="max-width: 496px;">
      <div class="topArea">
        <h4>{{ t('organization-subscription-change-payment-method') }}</h4>
        <div class="exit" @click.stop="dialogStore.close"></div>
      </div>
      <div class="scrollY">
        <div class="infoBoxWrap">
          <form class="checkout-form flex col gap-16" @submit.prevent="onSubmit" @keydown.enter.prevent>
            <div class="form-field flex col gap-8">
              <label for="card-name" class="form-field__title">{{ t('payment-cardholder-name') }}</label>
              <input
                id="card-name"
                v-model="form.cardName"
                type="text"
                name="card_name"
                :placeholder="t('payment-cardholder-name')"
                :class="{ error: errors.cardName }"
              />
              <p v-if="errors.cardName" class="errorMessage"><span class="icon"></span>{{ errors.cardName }}</p>
            </div>

            <div class="form-field flex col gap-8">
              <label for="card-number" class="form-field__title">{{ t('payment-card-number') }}</label>
              <div class="input-box flex item-center justify-between gap-8" :class="{ error: errors.cardNumber }">
                <div ref="stripeCardNumberRef" class="stripe-element"></div>
                <ul class="cards flex item-center gap-4">
                  <li class="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 30 20" fill="none">
                      <rect width="30" height="20" rx="3" fill="#141413"></rect>
                      <rect x="0.5" y="0.5" width="29" height="19" rx="2.5" stroke="#18367A" stroke-opacity="0.2"></rect>
                      <path d="M17.7045 4.41138H12.2983V14.774H17.7045V4.41138Z" fill="#FF5F00"></path>
                      <path d="M12.6421 9.5926C12.6421 7.57866 13.5174 5.65626 14.9934 4.41128C12.316 2.15933 8.4201 2.65366 6.30911 5.5281C4.21528 8.38424 4.67867 12.522 7.37319 14.7739C9.62148 16.6597 12.7622 16.6597 15.0105 14.7739C13.5174 13.5289 12.6421 11.6065 12.6421 9.5926Z" fill="#EB001B"></path>
                      <path d="M24.9998 9.5926C24.9998 13.236 22.2367 16.1837 18.8213 16.1837C17.4312 16.1837 16.0925 15.6894 15.0112 14.7739C17.6886 12.522 18.152 8.38424 16.041 5.5098C15.7321 5.10701 15.3888 4.72253 15.0112 4.41128C17.6886 2.15933 21.5845 2.65366 23.6783 5.5281C24.5364 6.68154 24.9998 8.10961 24.9998 9.5926Z" fill="#F79E1B"></path>
                    </svg>
                  </li>
                  <li class="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 30 20" fill="none">
                      <rect width="30" height="20" rx="3" fill="#0A4693"></rect>
                      <rect x="0.5" y="0.5" width="29" height="19" rx="2.5" stroke="#18367A" stroke-opacity="0.2"></rect>
                      <path d="M10.8333 13.5913L12.0993 6.15205H14.1235L12.8536 13.5913H10.8333ZM20.1618 6.31171C19.76 6.15966 19.1346 6 18.3499 6C16.3523 6 14.9422 7.01116 14.9309 8.45567C14.9195 9.52385 15.9353 10.1207 16.7048 10.478C17.4895 10.8429 17.7548 11.0748 17.751 11.3979C17.7472 11.8959 17.1218 12.124 16.5418 12.124C15.7307 12.124 15.3023 12.0099 14.639 11.7324L14.3774 11.6146L14.0931 13.2796C14.567 13.4887 15.4388 13.6673 16.3447 13.6749C18.4712 13.6749 19.851 12.679 19.8661 11.1318C19.8737 10.2841 19.3355 9.64169 18.168 9.1095C17.4629 8.76358 17.027 8.5355 17.0308 8.18577C17.0308 7.87787 17.3985 7.54715 18.1907 7.54715C18.8503 7.53574 19.3317 7.6802 19.7031 7.83225L19.8851 7.91968L20.1618 6.31171ZM25.3662 6.15205H23.8045C23.3193 6.15205 22.9592 6.2851 22.7469 6.76787L19.7411 13.5875H21.8638C21.8638 13.5875 22.2125 12.6714 22.2883 12.4699C22.5195 12.4699 24.5854 12.4737 24.8772 12.4737C24.9379 12.736 25.1236 13.5875 25.1236 13.5875H26.9999L25.3662 6.15205ZM22.8872 10.957C23.054 10.5274 23.6946 8.87762 23.6946 8.87762C23.6832 8.89663 23.8614 8.44807 23.9637 8.16677L24.1002 8.8092C24.1002 8.8092 24.4868 10.5844 24.5702 10.957H22.8872ZM9.11616 6.15205L7.1375 11.2269L6.92523 10.1967C6.55755 9.00687 5.40902 7.71821 4.12402 7.07578L5.9359 13.5799L8.07756 13.5761L11.2616 6.14825L9.11616 6.15205Z" fill="white"></path>
                    </svg>
                  </li>
                  <li class="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 30 20" fill="none">
                      <g clip-path="url(#clip0_card_change)">
                        <rect width="30" height="20" rx="3" fill="#286CB4"></rect>
                        <path d="M6.03439 8.18412L6.72425 9.85948H5.34454L6.03439 8.18412ZM20.4138 8.25579H17.753V8.9994H20.369V10.1103H17.753V10.9346H20.4138V11.5976L22.2684 9.59071L20.4138 7.49426V8.25579ZM7.83518 6.15935H11.4099L12.2073 7.88847L12.9419 6.15039H22.2146L23.1822 7.21653L24.1767 6.15039H28.4323L25.2876 9.59967L28.4054 13.0221H24.0781L23.1105 11.9559L22.1071 13.0221H6.98406L6.54506 11.9559H5.53268L5.09368 13.0221H1.59961L4.53821 6.15039H7.60224L7.83518 6.15935ZM15.5849 7.12694H13.578L12.2341 10.2895L10.7827 7.12694H8.79381V11.4273L6.94823 7.12694H5.16535L3.03307 12.0545H4.42174L4.86074 10.9883H7.19908L7.63808 12.0545H10.075V8.53353L11.6428 12.0545H12.709L14.2679 8.54249V12.0545H15.5759L15.5849 7.12694ZM23.9348 9.59967L26.2015 7.12694H24.5709L23.1374 8.66791L21.7488 7.12694H16.4808V12.0634H21.6771L23.1195 10.5045L24.5082 12.0634H26.1835L23.9348 9.59967Z" fill="white"></path>
                      </g>
                      <rect x="0.5" y="0.5" width="29" height="19" rx="2.5" stroke="#18367A" stroke-opacity="0.2"></rect>
                      <defs>
                        <clipPath id="clip0_card_change">
                          <rect width="30" height="20" rx="3" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </li>
                  <li class="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 30 20" fill="none">
                      <rect width="30" height="20" rx="3" fill="white"></rect>
                      <rect x="0.5" y="0.5" width="29" height="19" rx="2.5" stroke="#18367A" stroke-opacity="0.3"></rect>
                      <path d="M27.5 15.3729C27.5 17.5122 25.7579 19.2543 23.6186 19.2543H2.5V3.88142C2.5 1.74205 4.24205 0 6.38142 0H27.5V15.3729Z" fill="white"></path>
                      <path d="M20.6211 11.4299H22.2256C22.2715 11.4299 22.3784 11.4146 22.4243 11.4146C22.7299 11.3535 22.9897 11.0784 22.9897 10.6964C22.9897 10.3296 22.7299 10.0546 22.4243 9.97817C22.3784 9.96289 22.2867 9.96289 22.2256 9.96289H20.6211V11.4299Z" fill="url(#paint0_card_change)"></path>
                      <path d="M22.0445 1.29688C20.5164 1.29688 19.2633 2.53465 19.2633 4.07805V6.96619H23.1906C23.2823 6.96619 23.3892 6.96619 23.4657 6.98147C24.352 7.02732 25.009 7.48575 25.009 8.28037C25.009 8.9069 24.5659 9.44174 23.7407 9.54871V9.57927C24.6423 9.6404 25.33 10.1447 25.33 10.924C25.33 11.7645 24.5659 12.3146 23.5573 12.3146H19.248V17.9686H23.3281C24.8562 17.9686 26.1093 16.7309 26.1093 15.1875V1.29688H22.0445Z" fill="url(#paint1_card_change)"></path>
                      <path d="M22.791 8.46412C22.791 8.09737 22.5312 7.85287 22.2256 7.80703C22.1951 7.80703 22.1186 7.79175 22.0728 7.79175H20.6211V9.13649H22.0728C22.1186 9.13649 22.2103 9.13649 22.2256 9.12121C22.5312 9.07537 22.791 8.83087 22.791 8.46412Z" fill="url(#paint2_card_change)"></path>
                      <path d="M6.6695 1.29688C5.14138 1.29688 3.88833 2.53465 3.88833 4.07805V10.9393C4.66767 11.3213 5.47757 11.5658 6.28747 11.5658C7.25019 11.5658 7.76975 10.9851 7.76975 10.1905V6.95091H10.1536V10.1752C10.1536 11.4283 9.37427 12.4521 6.73063 12.4521C5.1261 12.4521 3.87305 12.1007 3.87305 12.1007V17.9534H7.95312C9.48124 17.9534 10.7343 16.7156 10.7343 15.1722V1.29688H6.6695Z" fill="url(#paint3_card_change)"></path>
                      <path d="M14.3593 1.29688C12.8312 1.29688 11.5781 2.53465 11.5781 4.07805V7.71497C12.2811 7.119 13.5036 6.73697 15.4748 6.82866C16.5292 6.8745 17.66 7.16485 17.66 7.16485V8.3415C17.0946 8.05115 16.4223 7.79137 15.5512 7.73025C14.0537 7.62328 13.1521 8.35678 13.1521 9.6404C13.1521 10.9393 14.0537 11.6728 15.5512 11.5505C16.4223 11.4894 17.0946 11.2144 17.66 10.9393V12.1159C17.66 12.1159 16.5445 12.4063 15.4748 12.4521C13.5036 12.5438 12.2811 12.1618 11.5781 11.5658V17.9839H15.6582C17.1863 17.9839 18.4394 16.7461 18.4394 15.2027V1.29688H14.3593Z" fill="url(#paint4_card_change)"></path>
                      <defs>
                        <linearGradient id="paint0_card_change" x1="19.2585" y1="10.6982" x2="26.1255" y2="10.6982" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#007940"></stop><stop offset="0.2285" stop-color="#00873F"></stop>
                          <stop offset="0.7433" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop>
                        </linearGradient>
                        <linearGradient id="paint1_card_change" x1="19.2606" y1="9.62608" x2="26.1281" y2="9.62608" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#007940"></stop><stop offset="0.2285" stop-color="#00873F"></stop>
                          <stop offset="0.7433" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop>
                        </linearGradient>
                        <linearGradient id="paint2_card_change" x1="19.2583" y1="8.46221" x2="26.1256" y2="8.46221" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#007940"></stop><stop offset="0.2285" stop-color="#00873F"></stop>
                          <stop offset="0.7433" stop-color="#40A737"></stop><stop offset="1" stop-color="#5CB531"></stop>
                        </linearGradient>
                        <linearGradient id="paint3_card_change" x1="3.88509" y1="9.62608" x2="10.8584" y2="9.62608" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#1F286F"></stop><stop offset="0.4751" stop-color="#004E94"></stop>
                          <stop offset="0.8261" stop-color="#0066B1"></stop><stop offset="1" stop-color="#006FBC"></stop>
                        </linearGradient>
                        <linearGradient id="paint4_card_change" x1="11.5386" y1="9.62608" x2="18.3113" y2="9.62608" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#6C2C2F"></stop><stop offset="0.1735" stop-color="#882730"></stop>
                          <stop offset="0.5731" stop-color="#BE1833"></stop><stop offset="0.8585" stop-color="#DC0436"></stop>
                          <stop offset="1" stop-color="#E60039"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </li>
                </ul>
              </div>
              <p v-if="errors.cardNumber" class="errorMessage"><span class="icon"></span>{{ errors.cardNumber }}</p>
            </div>

            <div class="form-grid flex gap-16">
              <div class="form-field flex col gap-8">
                <label for="card-exp" class="form-field__title">{{ t('payment-expiration-date') }}</label>
                <div class="input-box flex item-center gap-8" :class="{ error: errors.cardExp }">
                  <div ref="stripeCardExpiryRef" class="stripe-element"></div>
                </div>
                <p v-if="errors.cardExp" class="errorMessage"><span class="icon"></span>{{ errors.cardExp }}</p>
              </div>

              <div class="form-field flex col gap-8">
                <label for="cvc" class="form-field__title">{{ t('payment-security-code') }}</label>
                <div class="input-box flex item-center justify-between gap-8" :class="{ error: errors.cvc }">
                  <div ref="stripeCardCvcRef" class="stripe-element"></div>
                  <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="20" rx="3" fill="white"/>
                    <rect x="0.5" y="0.5" width="29" height="19" rx="2.5" stroke="#18367A" stroke-opacity="0.3"/>
                    <rect x="1" y="4" width="28" height="4" fill="#CDD4E4"/>
                    <rect x="1" y="4" width="28" height="4" fill="#C1C7D6"/>
                    <path d="M16.767 11.1818V17H15.8864V12.0625H15.8523L14.4602 12.9716V12.1307L15.9119 11.1818H16.767ZM18.3409 17V16.3636L20.3097 14.3239C20.5199 14.1023 20.6932 13.9081 20.8295 13.7415C20.9678 13.5729 21.071 13.4129 21.1392 13.2614C21.2074 13.1098 21.2415 12.9489 21.2415 12.7784C21.2415 12.5852 21.196 12.4186 21.1051 12.2784C21.0142 12.1364 20.8902 12.0275 20.733 11.9517C20.5758 11.8741 20.3987 11.8352 20.2017 11.8352C19.9934 11.8352 19.8116 11.8778 19.6562 11.9631C19.5009 12.0483 19.3816 12.1686 19.2983 12.3239C19.215 12.4792 19.1733 12.661 19.1733 12.8693H18.3352C18.3352 12.5152 18.4167 12.2055 18.5795 11.9403C18.7424 11.6752 18.9659 11.4697 19.25 11.3239C19.5341 11.1761 19.857 11.1023 20.2188 11.1023C20.5843 11.1023 20.9063 11.1752 21.1847 11.321C21.465 11.465 21.6837 11.6619 21.8409 11.9119C21.9981 12.16 22.0767 12.4403 22.0767 12.7528C22.0767 12.9688 22.036 13.1799 21.9545 13.3864C21.875 13.5928 21.7358 13.8229 21.5369 14.0767C21.3381 14.3286 21.0616 14.6345 20.7074 14.9943L19.5511 16.2045V16.2472H22.1705V17H18.3409ZM25.2727 17.0795C24.8826 17.0795 24.5341 17.0123 24.2273 16.8778C23.9223 16.7434 23.6809 16.5568 23.5028 16.3182C23.3267 16.0777 23.232 15.7992 23.2188 15.483H24.1108C24.1222 15.6553 24.1799 15.8049 24.2841 15.9318C24.3902 16.0568 24.5284 16.1534 24.6989 16.2216C24.8693 16.2898 25.0587 16.3239 25.267 16.3239C25.4962 16.3239 25.6989 16.2841 25.875 16.2045C26.053 16.125 26.1922 16.0142 26.2926 15.8722C26.393 15.7282 26.4432 15.5625 26.4432 15.375C26.4432 15.1799 26.393 15.0085 26.2926 14.8608C26.1941 14.7112 26.0492 14.5937 25.858 14.5085C25.6686 14.4233 25.4394 14.3807 25.1705 14.3807H24.679V13.6648H25.1705C25.3864 13.6648 25.5758 13.6259 25.7386 13.5483C25.9034 13.4706 26.0322 13.3627 26.125 13.2244C26.2178 13.0843 26.2642 12.9205 26.2642 12.733C26.2642 12.553 26.2235 12.3968 26.142 12.2642C26.0625 12.1297 25.9489 12.0246 25.8011 11.9489C25.6553 11.8731 25.483 11.8352 25.2841 11.8352C25.0947 11.8352 24.9176 11.8703 24.7528 11.9403C24.59 12.0085 24.4574 12.107 24.3551 12.2358C24.2528 12.3627 24.1979 12.5152 24.1903 12.6932H23.3409C23.3504 12.3788 23.4432 12.1023 23.6193 11.8636C23.7973 11.625 24.0322 11.4384 24.3239 11.304C24.6155 11.1695 24.9394 11.1023 25.2955 11.1023C25.6686 11.1023 25.9905 11.1752 26.2614 11.321C26.5341 11.465 26.7443 11.6572 26.892 11.8977C27.0417 12.1383 27.1155 12.4015 27.1136 12.6875C27.1155 13.0133 27.0246 13.2898 26.8409 13.517C26.6591 13.7443 26.4167 13.8968 26.1136 13.9744V14.0199C26.5 14.0786 26.7992 14.232 27.0114 14.4801C27.2254 14.7282 27.3314 15.036 27.3295 15.4034C27.3314 15.7235 27.2424 16.0104 27.0625 16.2642C26.8845 16.518 26.6411 16.7178 26.3324 16.8636C26.0237 17.0076 25.6705 17.0795 25.2727 17.0795Z" fill="#767A85"/>
                  </svg>
                </div>
                <p v-if="errors.cvc" class="errorMessage"><span class="icon"></span>{{ errors.cvc }}</p>
              </div>
            </div>

            <div class="form-field flex col gap-8">
              <label class="form-field__title">{{ t('account-country') }}</label>
              <CommonCountrySelect v-model="form.country" />
            </div>
          </form>
        </div>

        <div class="btnArea">
          <button
            type="button"
            class="btn"
            :class="{ disabled: isLoading }"
            :disabled="isLoading"
            @click="onSubmit"
          >
            {{ t('organization-subscription-change-payment-method') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { loadStripe } from '@stripe/stripe-js';
import type { Stripe, StripeElements, StripeCardNumberElement, StripeCardExpiryElement, StripeCardCvcElement } from '@stripe/stripe-js';
import { useI18n } from 'vue-i18n';
import { useDialogStore } from '~/store/dialog/dialogStore';
import { useToastStore } from '~/store/toast/toastStore';
import { ToastType } from '~/components/Common/Toast/model/ToastType';
import { useUserStore } from '~/store/user/userStore';
import { useUserService } from '~/composables/service/useUserService';
import { usePaymentError } from '~/composables/usePaymentError';
import { useStripeSetupIntent } from '~/composables/useStripeSetupIntent';
import { useGenericDialog } from '~/composables/useGenericDialog';
import { useSubscriptionBroadcast } from '~/composables/useSubscriptionBroadcast';
import { useContainer } from '~/composables/useContainer';
import { DependencyInjectId } from '@@/package/const/DependencyInjectId';
import type SubscriptionApi from '@@/package/apis/subscription/SubscriptionApi';
import { applicationContext } from '@@/package/application/applicationContext';

const { t } = useI18n();
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const userStore = useUserStore();
const { getErrorCode } = usePaymentError();
const { confirmStripeSetup } = useStripeSetupIntent();
const { openGenericAlert } = useGenericDialog();
const { notifySubscriptionUpdate } = useSubscriptionBroadcast();
const subscriptionApi = useContainer<SubscriptionApi>(DependencyInjectId.SubscriptionApi);

const stripe = ref<Stripe | null>(null);
const stripeElements = ref<StripeElements | null>(null);
const stripeCardNumberRef = ref<HTMLElement | null>(null);
const stripeCardExpiryRef = ref<HTMLElement | null>(null);
const stripeCardCvcRef = ref<HTMLElement | null>(null);
let cardNumberEl: StripeCardNumberElement | null = null;
let cardExpiryEl: StripeCardExpiryElement | null = null;
let cardCvcEl: StripeCardCvcElement | null = null;

const cardNumberComplete = ref(false);
const cardExpiryComplete = ref(false);
const cardCvcComplete = ref(false);
const cardNumberEmpty = ref(true);
const cardExpiryEmpty = ref(true);
const cardCvcEmpty = ref(true);
const submitted = ref(false);
const isLoading = ref(false);

const form = reactive({ cardName: '', country: '' });
const errors = reactive({ cardName: '', cardNumber: '', cardExp: '', cvc: '' });

const locationToNationCode = (location: string): string =>
  /\(([A-Z]{2})\)$/.exec(location.trim())?.[1] ?? '';

watch(
  () => userStore.userV2.location,
  (location) => {
    if (!form.country && location) form.country = locationToNationCode(location);
  },
  { immediate: true },
);

const stripeElementStyle = {
  base: {
    fontSize: '14px',
    color: '#2b2e37',
    fontFamily: 'inherit',
    '::placeholder': { color: '#AFB4C4' },
  },
  invalid: { color: '#2b2e37' },
};

const mountStripeElements = (elements: StripeElements) => {
  if (cardNumberEl) return;

  cardNumberEl = elements.create('cardNumber', { style: stripeElementStyle });
  cardNumberEl.mount(stripeCardNumberRef.value!);
  cardNumberEl.on('change', (e) => {
    cardNumberComplete.value = e.complete;
    cardNumberEmpty.value = e.empty;
    if (submitted.value) {
      errors.cardNumber = e.complete ? '' : (e.empty ? t('payment-card-number-error-1') : t('payment-card-number-error-2'));
    }
  });

  cardExpiryEl = elements.create('cardExpiry', { style: stripeElementStyle });
  cardExpiryEl.mount(stripeCardExpiryRef.value!);
  cardExpiryEl.on('change', (e) => {
    cardExpiryComplete.value = e.complete;
    cardExpiryEmpty.value = e.empty;
    if (submitted.value) {
      errors.cardExp = e.complete ? '' : (e.empty ? t('payment-expiration-date-error-1') : t('payment-expiration-date-error-2'));
    }
  });

  cardCvcEl = elements.create('cardCvc', { style: stripeElementStyle });
  cardCvcEl.mount(stripeCardCvcRef.value!);
  cardCvcEl.on('change', (e) => {
    cardCvcComplete.value = e.complete;
    cardCvcEmpty.value = e.empty;
    if (submitted.value) {
      errors.cvc = e.complete ? '' : (e.empty ? t('payment-security-code-error-1') : t('payment-security-code-error-2'));
    }
  });
};

const validateCardName = () => {
  const trimmed = form.cardName.trim();
  if (!trimmed) errors.cardName = t('payment-cardholder-name-error-1');
  else if (trimmed.length > 20) errors.cardName = t('payment-cardholder-name-error-2');
  else errors.cardName = '';
};

const validateAll = (): boolean => {
  submitted.value = true;
  validateCardName();
  errors.cardNumber = cardNumberComplete.value ? '' : (cardNumberEmpty.value ? t('payment-card-number-error-1') : t('payment-card-number-error-2'));
  errors.cardExp    = cardExpiryComplete.value ? '' : (cardExpiryEmpty.value ? t('payment-expiration-date-error-1') : t('payment-expiration-date-error-2'));
  errors.cvc        = cardCvcComplete.value    ? '' : (cardCvcEmpty.value    ? t('payment-security-code-error-1')    : t('payment-security-code-error-2'));
  return !Object.values(errors).some(Boolean);
};

const FIELD_SERVER_ERROR_MAP: Record<string, { field: keyof typeof errors; key: string }> = {
  CARD_EXPIRED:        { field: 'cardExp',    key: 'payment-expiration-date-error-2' },
  CARD_NUMBER_INVALID: { field: 'cardNumber', key: 'payment-card-number-error-2' },
  CARD_CVC_INVALID:    { field: 'cvc',        key: 'payment-security-code-error-2' },
};

const applyServerError = (code: string): boolean => {
  const mapping = FIELD_SERVER_ERROR_MAP[code];
  if (!mapping) return false;
  errors[mapping.field] = t(mapping.key);
  return true;
};

const openPaymentErrorAlert = () => {
  const contactLink = `<a class="link" href="/home/contact" target="_blank">${t('common-contact-us')}</a>`;
  openGenericAlert(
    { title: t('payment-payment-method-change-fail-title'), contents: t('payment-error-contents', { contact: contactLink }) },
    { confirm: { title: t('common-ok'), event: () => {} } },
  );
};

// PAY-PROC-03, PAY-SUB-12: 결제수단(카드) 변경 — POST /api/v1/payment-methods.
const onSubmit = async () => {
  if (isLoading.value) return;
  if (!validateAll()) return;

  isLoading.value = true;
  try {
    if (!stripe.value) throw new Error('Stripe is not loaded.');
    if (!cardNumberEl) throw new Error('Card element is not ready.');

    const { setupIntentId } = await confirmStripeSetup(stripe.value, cardNumberEl, form.cardName);
    await subscriptionApi.updatePaymentMethod({
      providerType: 'STRIPE',
      setupIntentId,
      country: form.country,
    });

    notifySubscriptionUpdate();
    useUserService().setUser().catch(() => {});
    toastStore.openToast({
      toastType: ToastType.SUCCESS,
      contents: t('organization-subscription-change-payment-method-success'),
    });
    dialogStore.close();
  } catch (error) {
    const errorCode = getErrorCode(error);
    if (!errorCode || !applyServerError(errorCode)) {
      openPaymentErrorAlert();
    }
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  const stripeInstance = await loadStripe(applicationContext.getConfig().STRIPE_PUBLISHABLE_KEY);
  if (stripeInstance) {
    stripe.value = stripeInstance;
    stripeElements.value = stripeInstance.elements();
    await nextTick();
    mountStripeElements(stripeElements.value);
  }
});

onUnmounted(() => {
  cardNumberEl?.destroy();
  cardExpiryEl?.destroy();
  cardCvcEl?.destroy();
});
</script>

<style scoped>
.stripe-element {
  flex: 1;
  height: 20px;
}
</style>
